module.exports = __webpack_public_path__ + "media/St 4-computer-incorrect.6d1d6a70.wav";